import {
    createOptionPicker,
    OptionPicker,
} from '@vfde-brix/ws10/option-picker';
import { PriceType } from '@vfde-sails/glados-v2';
import {
    selectCustomerConfig,
    setPaymentMethod,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { IInitialState } from 'Container/App/interface';
import { startAppListening } from 'Container/App/listener';

const mountPaymentPicker = (
    containerId: string,
    customerConfig: IInitialState['customerConfig'],
): OptionPicker | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore next */
    if (!container) {
        return null;
    }

    const dispatch = useDispatch();

    const picker = createOptionPicker(container, {
        onChange: (event: Event) => {
            dispatch(setPaymentMethod((event.target as HTMLInputElement).value as PriceType));
        },
    });

    picker.update({
        items: [
            ...picker.getProperties().items.map(item => ({
                ...item,
                optChecked: item.stdValue === customerConfig.paymentMethod,
            })),
        ],
    });

    picker.toggleContainer(customerConfig.isHardwareOnly !== false, true);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectCustomerConfig(currentState) !== selectCustomerConfig(previousState),
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const { isHardwareOnly } = selectCustomerConfig(listenerApi.getState());

            picker.toggleContainer(isHardwareOnly !== false, true);
        },
    });

    return picker;
};

export default mountPaymentPicker;
